import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Avatar,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import { useGeneralProfile } from "../../contexts/Organization";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import useResize from "../../hooks/useResize";
import { useAuth } from "../../contexts/Auth";
import { treatment_program } from "../../constants/common";

const PostTypeSelectionModal = ({
  open,
  onClose,
  accountType,
  setAccountType,
}) => {
  const isMobileView = useResize(600);
  const [selectedUser, setSelectedUser] = useState(accountType);
  const { account_type } = useAuth();
  const { facilityInfo } = useGeneralProfile();
  const { data } = useBasicInfo();

  const info = account_type === treatment_program ? facilityInfo : data;

  const resetSelection = () => {
    setSelectedUser(accountType);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobileView ? "sm" : "xs"}
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5" fontWeight={600}>
          Post as
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            p: 0.25,
            color: "border.dark",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ mb: 1 }} />
      <DialogContent>
        <RadioGroup
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <FormControlLabel
            value="user"
            control={<Radio />}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Avatar
                  sx={{ width: 32, height: 32 }}
                  src={info?.user_info?.user_profile_image}
                />
                <Box>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    textTransform="capitalize"
                  >
                    {info?.first_name} {info?.last_name}{" "}
                    {info?.professional_degree &&
                      ", " + info?.professional_degree}
                  </Typography>
                </Box>
              </Box>
            }
          />
          <FormControlLabel
            value="treatment_program"
            control={<Radio />}
            sx={{ mt: 2 }}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Avatar
                  sx={{ width: 32, height: 32 }}
                  src={
                    info?.main_image ||
                    info?.program_info?.treatment_program_image
                  }
                />
                <Box>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    textTransform="capitalize"
                  >
                    {info?.info?.facility_name ||
                      info?.program_info?.treatment_program_name}
                  </Typography>
                </Box>
              </Box>
            }
          />
        </RadioGroup>
      </DialogContent>
      <Divider sx={{ my: 1 }} />
      <DialogActions>
        <Button
          onClick={() => {
            setAccountType(selectedUser);
            resetSelection();
            onClose();
          }}
          variant="contained"
          sx={{ minWidth: "25%" }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PostTypeSelectionModal;
